import '../styles/DoublePage.scss';

const DoublePage = ({ id, minor, major, poster }) => {
    const style = poster && {backgroundImage: `url('${poster}')`};
    return <article className="double-page" id={id}>
        <section className="minor">{minor}</section>
        <section className="major" style={style}>{major}</section>
    </article>
}

export default DoublePage;